document.addEventListener('DOMContentLoaded', function () {
        const learnMoreBtn = document.getElementById('learnMoreBtn');
        const modal = document.getElementById('modal-custom');
        const closeBtn = document.querySelector('.close');
        const form = document.getElementById('contactForm');
        const successModal = document.getElementById('success-modal');

        // 显示弹出框
        learnMoreBtn.addEventListener('click', function () {
            modal.style.display = 'block';
        });

        // 隐藏弹出框
        closeBtn.addEventListener('click', function () {
            modal.style.display = 'none';
            successModal.style.display = 'none';
        });

        // 点击外部隐藏弹出框
        window.addEventListener('click', function (event) {
            if (event.target === modal || event.target === successModal) {
                modal.style.display = 'none';
                successModal.style.display = 'none';
            }
        });
    });